export const invoiceLimits = { maxFiles: 10, maxFileBytes: 20 * 1024 * 1024, maxBatchBytes: 100 * 1024 * 1024 }

// Only format the server's invoice line amount; missing history must not use retail prices.
export function formatInvoiceLineAmount(value) {
  if (value == null || value === '') return '—'
  const amount = Number(value)
  return Number.isFinite(amount) ? amount.toFixed(2) : '—'
}

// The list API does not expose a source yet; completed invoices use a neutral label.
export function invoiceStateText(row) {
  if (!row) return ''
  const sourceMissing = row.invoiceSource == null || row.invoiceSource === ''
  if (Number(row.state) === 2 && (sourceMissing || row.invoiceSource === 'MANUAL')) return '已开票'
  return row.stateStr || ''
}

export function operationId() {
  const bytes = new Uint8Array(16)
  window.crypto.getRandomValues(bytes)
  return Array.from(bytes, n => n.toString(16).padStart(2, '0')).join('')
}

export function invoiceIdOf(value) {
  if (typeof value === 'number' && !Number.isSafeInteger(value)) throw new Error('申请编号无效，请刷新列表后重试')
  const id = String(value == null ? '' : value)
  if (!/^[1-9]\d{0,18}$/.test(id)) throw new Error('未获取到发票申请编号，请刷新后重试')
  return id
}

export function replyData(response) {
  if (!response || String(response.code) !== '0' || response.data == null) {
    const error = new Error((response && (response.message || response.msg)) || '操作未完成，请重试')
    error.businessFailure = !!response && response.code != null && String(response.code) !== '0'
    throw error
  }
  return response.data
}

export function displaySize(bytes) {
  if (bytes == null) return ''
  return bytes >= 1024 * 1024 ? (bytes / 1024 / 1024).toFixed(2) + ' MB' : (bytes / 1024).toFixed(1) + ' KB'
}

export function validateSelection(existing, incoming, limits = invoiceLimits) {
  if (existing.length + incoming.length > limits.maxFiles) throw new Error('每条申请最多上传' + limits.maxFiles + '个文件')
  let total = existing.reduce((sum, item) => sum + item.raw.size, 0)
  incoming.forEach(file => {
    if (!/\.(pdf|jpe?g|png|gif)$/i.test(file.name) || (file.type && !/^(application\/pdf|image\/(jpeg|png|gif))$/i.test(file.type))) {
      throw new Error('仅支持 PDF、JPG、PNG、GIF 文件')
    }
    if (!file.size || file.size > limits.maxFileBytes) throw new Error('单个文件不能为空且不能超过' + displaySize(limits.maxFileBytes))
    total += file.size
  })
  if (total > limits.maxBatchBytes) throw new Error('本次文件总大小不能超过' + displaySize(limits.maxBatchBytes))
}

export function sameCompletedFiles(result, ids) {
  return result && Number(result.state) === 2 && result.invoiceSource === 'MANUAL' && result.manualCompleted === true &&
    Array.isArray(result.attachments) && result.attachments.length === ids.length &&
    result.attachments.every((item, index) => item.attachmentId === ids[index])
}
